import axios from "axios";
import Base64 from "base-64";
import config from "../config/config";

const calcItemPrice = (item) => {
  let itemTotal = 0;
  if (item.hasOwnProperty('product') && item.hasOwnProperty('quantity')) {
    if (item.product.price) {
      itemTotal = item.product.price * item.quantity;
    }
  }
  return itemTotal;
}

export const calcSubTotal = (cart) => {
  let total = 0;
  if (cart) {
    if (cart.items instanceof Array && cart.items.length > 0) {
      total = cart.items.map(calcItemPrice).reduce((a, b) => a + b);
    }
  }
  return total;
}

export const countCartItems = (cart) => {
  let num = 0;
  if (cart) {
    if (cart.items instanceof Array) {
      if (cart.items.length > 0) {
        num = cart.items.map(item => item.quantity).reduce((a, b) => a + b);
      }
    }
  }
  return num;
}


const fetchDataResponse = async (url, params) => {
  const hash = Base64.encode(config.auth.name + ':' + config.auth.pass);
  const Basic = 'Basic ' + hash;
  return await axios({
    method: 'get',
    url: url,
    headers: { Authorization: Basic }
  }).catch(e => console.log(e));
}

const assignLinkPath = link => {
  return link === '/' + config.mainPageAlias ? '/' : link;
}

export const mergeMainMenu = (menus, store) => {
  menus.forEach(menu => {
    switch (menu.key) {
      case 'main':
        if (menu.items) {
          if (menu.items instanceof Array) {
            const mainMenu = menu.items.map(item => {
              return {
                title: item.title,
                to: assignLinkPath(item.link)
              }
            });
            store.commit('setMainMenu', mainMenu);
            break;
          }
        }
    }
  });
}

export const fetchSiteData = async () => {
  const response = await fetchDataResponse(config.cmsApi.site)
  let data = {
    valid: false,
  }
  if (response.data) {
    if (response.data.pages instanceof Array) {
      const d = response.data;
      data.valid = true;
      if (d.main) {
        data.hasMain = false;
        data.main = d.main;
        if (d.main.title) {
          data.hasMain = true;
        }
      }
      if (d.pages) {
        if (d.pages instanceof Array) {
          data.pages = d.pages.map(mapPosts);
          data.numPages = data.pages.length;
        }
      }
      if (d.products) {
        if (d.products instanceof Array) {
          data.products = d.products.map(mapPosts);
          data.numProducts = data.products.length;
        }
      }
      if (d.menus) {
        if (d.menus instanceof Array) {
          data.menus = d.menus;
        }
      }
      data.valid = true;
    }
  }
  return data;
}


export const fetchPosts = async () => {
  const response = fetchDataResponse(config.cmsApi.posts)
  let posts = [];
  if (response.data) {
    if (response.data instanceof Array) {
      posts = response.data;
    }
  }
  return posts.map(mapPosts);
}

export const mapPosts = (post) => {
  post.hasProduct = false;
  post.available = false;
  if (post.content instanceof Array) {
    post.hasPreviewImage = false;
    if (post.image_src) {
      post.hasPreviewImage = post.image_src.length > 4;
    }
    const numSecs = post.content.length;
    let product = post.content.find(sec => sec.type === "ec-store");
    if (product) {
      if (product.data) {
        post.price = product.data.price;
        post.priceGross = product.data.defaultDisplayedPrice;
        post.productId = product.data.id;
        post.hasProduct = true;
        post.available = product.data.enabled === true;
        if (product.data.options) {
          post.options = product.data.options;
        } else {
          post.options = [];
        }
      }
      post.slug = post.slug.split('/').pop();
      post.routerLink = '/products/' + post.slug;
    }
    let sec = {};
    let sections = [];
    post.hasMainText = false;
    post.hasMainMedia = false;
    post.mainMedia = {
      type: "image",
      img: { src: "", caption: "" },
      items: []
    };
    for (let i = 0; i < numSecs; i++) {
      sec = post.content[i];
      switch (sec.type) {
        case 'ec-store':
          break;
        case 'image':
        case 'gallery':
          if (!post.hasMainMedia) {
            switch (sec.type) {
              case "gallery":
                post.mainMedia.items = sec.items;
                post.mainMedia.type = 'gallery';
                post.hasMainMedia = sec.items.length > 0;
                break;
              case "image":
                post.mainMedia.image = sec;
                post.mainMedia.type = 'image';
                post.hasMainMedia = sec.src.length > 4;
                break;
            }
          } else {
            sections.push(sec);
          }
          break;
        case 'text':
          if (!post.hasMainText) {
            if (sec.markup.length > 5) {
              post.mainText = sec.markup;
              post.hasMainText = true;
            }
          } else {
            sections.push(sec);
          }
          break;
        default:
          sections.push(sec);
          break;
      }
    }
    post.content = sections;
  }
  return post;
}

export const getVersion = () => {
  let version = 1;
  if (config.hasOwnProperty('version')) {
    version = parseFloat(config.version);
  }
  return version;
}

